export enum InfoReason {
  ERROR = 'ERROR',
  WRONG_HASH = 'WRONG_HASH',
  OFFER_NOT_FOUND = 'OFFER_NOT_FOUND',
  LEAD_DETAILS = 'LEAD_DETAILS',
  SUCCESS_WITH_BEGIN = 'SUCCESS_WITH_BEGIN',
  CHAT = 'CHAT',
}
